import type { PendingAgreement } from "@/stores/useAgreementAcceptanceStore";

const AGREEMENT_TITLES: Record<string, string> = {
	"terms-of-service": "利用規約",
	"privacy-policy": "プライバシーポリシー",
	"device-cancellation-policy": "キャンセルポリシー",
};

/** 画面に出す文書名。知らない文書はサーバーの id をそのまま出す。 */
export function agreementTitle(id: string): string {
	return AGREEMENT_TITLES[id] ?? id;
}

/** 同意の画面で、文書の名前の下に出す説明。 */
export function agreementLead(id: string): string {
	return id === "device-cancellation-policy"
		? "デバイスを利用するには、ローカル環境版のキャンセルポリシーを確認して同意してください。"
		: `Izanagi を利用するには、${agreementTitle(id)}を確認して同意してください。`;
}

/** API が返す同意が必要な文書の一覧を読み取る。形が崩れた要素は捨てる。 */
export function parsePendingAgreements(value: unknown): PendingAgreement[] {
	if (!Array.isArray(value)) return [];
	return value.flatMap((item: unknown) => {
		if (typeof item !== "object" || item === null) return [];
		const { id, version } = item as { id?: unknown; version?: unknown };
		return typeof id === "string" && typeof version === "string" ? [{ id, version }] : [];
	});
}
